module.exports = __webpack_public_path__ + "img/view-id.dbf684ae.svg";